import { useEffect, useRef } from 'react'
import { gql, useSubscription } from '@apollo/client'

import { GroupWorkoutHit } from 'interfaces/group-workout'
import { useGroupWorkoutSessionActions } from 'store/group-workout-session/selectors'
import type { GroupWorkoutHitRoundTarget } from 'store/group-workout-session'
import { getGroupWorkoutHitKey } from 'lib/group-workout-hits'

const HIT = gql`
  subscription addGroupWorkoutHit {
    hit {
      force
      angle
      height
      punchedAt
      bag {
        id
      }
    }
  }
`

const useAddGroupHit = (target: GroupWorkoutHitRoundTarget) => {
  const { data } = useSubscription<{ hit: GroupWorkoutHit }>(HIT)
  const { addGroupWorkoutHit } = useGroupWorkoutSessionActions()
  const processedHitKeyRef = useRef<string | null>(null)

  useEffect(() => {
    if (data && data.hit) {
      const hitKey = getGroupWorkoutHitKey(data.hit)
      if (processedHitKeyRef.current === hitKey) return

      processedHitKeyRef.current = hitKey
      addGroupWorkoutHit(data.hit, target)
    }
  }, [data, addGroupWorkoutHit, target])
}

export default useAddGroupHit
